<template>
  <b-card title="نظرات و امتیازهای مشاوران">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                  label="موبایل کاربر"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="توصیه"
                  label-for="IsRecommended"
                >
                  <v-select
                    v-model="filterOptions.IsRecommended"
                    :options="recommendOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openDetails(data.item.Id)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Consultant)="data">
            <span>{{ (data.item.ConsultantName || '') + ' ' + (data.item.ConsultantFamily || '') }}</span>
          </template>

          <template #cell(Reviewer)="data">
            <div>
              <div>{{ (data.item.ReviewerName || '') + ' ' + (data.item.ReviewerFamily || '') }}</div>
              <small class="text-muted">{{ data.item.ReviewerMobile }}</small>
            </div>
          </template>

          <template #cell(Average)="data">
            <b-badge variant="light-warning">{{ avg(data.value) }} ⭐</b-badge>
          </template>

          <template #cell(IsRecommended)="data">
            <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
              {{ data.value ? 'توصیه می‌کند' : 'توصیه نمی‌کند' }}
            </b-badge>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">{{ statusText(data.value) }}</b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            <span class="text-nowrap">{{ data.value | date('date-time') }}</span>
          </template>

          <template #cell(actions)="data">
            <feather-icon
              icon="EyeIcon"
              size="16"
              class="cursor-pointer mr-1"
              @click="openDetails(data.item.Id)"
            />
            <feather-icon
              icon="Trash2Icon"
              size="16"
              class="cursor-pointer text-danger"
              @click="remove(data.item.Id)"
            />
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <!-- مدال جزئیات نظر -->
    <b-modal
      v-if="showModal"
      v-model="showModal"
      centered
      hide-footer
      title="جزئیات نظر"
      :no-close-on-backdrop="true"
      size="lg"
    >
      <div
        v-if="detailLoading"
        class="text-center my-3"
      >
        <b-spinner variant="primary" />
      </div>

      <div v-else-if="detail">
        <b-row>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">مشاور</small>
            <div class="font-weight-bold">{{ detail.ConsultantName }} {{ detail.ConsultantFamily }}</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">کاربر</small>
            <div class="font-weight-bold">{{ detail.ReviewerName }} {{ detail.ReviewerFamily }} - {{ detail.ReviewerMobile }}</div>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">امتیازها (از ۵)</small>
            <b-row class="mt-25">
              <b-col
                v-for="s in scoreRows"
                :key="s.key"
                md="6"
                class="mb-50"
              >
                <div class="d-flex justify-content-between">
                  <span>{{ s.label }}</span>
                  <b-badge variant="light-warning">{{ detail[s.key] }} ⭐</b-badge>
                </div>
              </b-col>
            </b-row>
            <div class="mt-50">
              <b-badge variant="warning">میانگین: {{ avg(detail.Average) }} ⭐</b-badge>
            </div>
          </b-col>

          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">توصیه</small>
            <div>
              <b-badge :variant="detail.IsRecommended ? 'light-success' : 'light-danger'">
                {{ detail.IsRecommended ? 'توصیه می‌کند' : 'توصیه نمی‌کند' }}
              </b-badge>
            </div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">وضعیت</small>
            <div><b-badge :variant="statusVariant(detail.Status)">{{ statusText(detail.Status) }}</b-badge></div>
          </b-col>

          <b-col
            v-if="detail.Tags && detail.Tags.length"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">تگ‌ها</small>
            <div>
              <b-badge
                v-for="t in detail.Tags"
                :key="t.Id"
                variant="light-primary"
                class="mr-50 mb-25"
              >{{ t.Emoji }} {{ t.Title }}</b-badge>
            </div>
          </b-col>

          <b-col
            v-if="detail.Comment"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">توضیحات</small>
            <div style="white-space: pre-line;">{{ detail.Comment }}</div>
          </b-col>

          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">تاریخ ثبت</small>
            <div class="font-weight-bold">{{ detail.CreatedAt | date('date-time') }}</div>
          </b-col>
          <b-col
            v-if="detail.UpdatedAt"
            md="6"
            class="mb-1"
          >
            <small class="text-muted">آخرین ویرایش</small>
            <div class="font-weight-bold">{{ detail.UpdatedAt | date('date-time') }}</div>
          </b-col>

          <b-col
            v-if="detail.Status === 2 && detail.RejectReason"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دلیل رد</small>
            <div class="text-danger">{{ detail.RejectReason }}</div>
          </b-col>
        </b-row>

        <hr>
        <div class="d-flex flex-wrap justify-content-end">
          <b-button
            v-if="detail.Status !== 2"
            variant="outline-danger"
            class="mr-1 mb-1"
            @click="openReject"
          >
            رد نظر
          </b-button>
          <b-button
            v-if="detail.Status !== 1"
            variant="success"
            class="mb-1"
            @click="accept"
          >
            تأیید
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- مدال رد با دلیل -->
    <b-modal
      v-if="showReject"
      v-model="showReject"
      centered
      ok-title="ثبت رد"
      cancel-title="انصراف"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      title="رد نظر"
      :no-close-on-backdrop="true"
      @ok="reject"
    >
      <b-form-group
        label="دلیل رد (اختیاری)"
        label-for="RejectReason"
      >
        <b-form-textarea
          v-model="rejectReason"
          rows="3"
          no-resize
          placeholder="مثلاً متن نامناسب است…"
        />
      </b-form-group>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'ConsultingReview',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Mobile: null,
        Status: null,
        IsRecommended: null,
        ProfileId: null,
        Page: 1,
        PerPage: 10,
      },
      statusOptions: [
        { text: 'در انتظار بررسی', value: 0 },
        { text: 'تأییدشده', value: 1 },
        { text: 'رد شده', value: 2 },
      ],
      recommendOptions: [
        { text: 'توصیه می‌کند', value: true },
        { text: 'توصیه نمی‌کند', value: false },
      ],
      items: [],
      showModal: false,
      detail: null,
      detailLoading: false,
      showReject: false,
      rejectReason: null,
      scoreRows: [
        { key: 'ScoreBehavior', label: 'نحوه برخورد و پاسخگویی' },
        { key: 'ScoreClarity', label: 'وضوح و شفافیت توضیحات' },
        { key: 'ScoreExpertise', label: 'تخصص و مهارت' },
        { key: 'ScoreUsefulness', label: 'کاربردی بودن راهکارها' },
      ],
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Consultant', label: 'مشاور' },
        { key: 'Reviewer', label: 'کاربر' },
        { key: 'Average', label: 'امتیاز' },
        { key: 'IsRecommended', label: 'توصیه' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'CreatedAt', label: 'تاریخ' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    avg(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    },
    statusText(value) {
      return ['در انتظار بررسی', 'تأییدشده', 'رد شده'][value] || '—'
    },
    statusVariant(value) {
      return ['light-warning', 'light-success', 'light-danger'][value] || 'light-secondary'
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.consultingreview.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetails(id) {
      this.showModal = true
      this.detail = null
      this.detailLoading = true
      this.$http.post(this.$api.consultingreview.get, { Id: id })
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    accept() {
      this.$http.post(this.$api.consultingreview.accept, { Id: this.detail.Id })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    openReject() {
      this.rejectReason = this.detail.RejectReason || null
      this.showReject = true
    },
    reject() {
      this.$http.post(this.$api.consultingreview.reject, { Id: this.detail.Id, RejectReason: this.rejectReason })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.consultingreview.remove, 'Id', id)
    },
  },
}
</script>
